import { render, staticRenderFns } from "./CompositePromotion.vue?vue&type=template&id=6c178621&scoped=true"
import script from "./CompositePromotion.vue?vue&type=script&lang=js"
export * from "./CompositePromotion.vue?vue&type=script&lang=js"
import style0 from "./CompositePromotion.vue?vue&type=style&index=0&id=6c178621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c178621",
  null
  
)

export default component.exports